import { AuthService } from "./AuthService";
import { ApiService } from "./ApiService";
import { SERVICE_URL } from "../evironment";
import { UiService } from "./UiService";
import { QueryParamsFactory } from "./QueryParamsFactory";
import { UsersService } from "./UsersService";
import { ThirdsService } from "./ThirdsService";
import { ParamsService } from "./ParamsService";
import { DirectionsService } from "./DirectionsService";
import { KinshipsService } from "./KinshipsService";
import { ParentsService } from "./ParentsService";
import { VehiclesService } from "./VehiclesService";
import { DiligencesService } from "./DiligencesService";
import { SubtypesDiligencesService } from "./SubtypesDiligencesService";
import { ComplainantService } from "./ComplainantService";
import { DenouncedService } from "./DenouncedService";
import { ComplainantTrafficService } from "./ComplainantTrafficService";
import { ComplainantGenderService } from "./ComplainantGenderService";
import { DenouncedGenderService } from "./DenouncedGenderService";
import { BussinessService } from "./BussinessService";
import { WitnessService } from "./WitnessService";
import { ComplainantActaService } from "./ComplainantActaService";
import { LawService } from "./LawService";
import { LawArticleService } from "./LawArticleService";
import { DenouncedActaService } from "./DenouncedActaService";
import { WitnessGenderService } from "./WitnessGenderService";
import { ComplainantGeneralService } from "./ComplainantGeneralService";
import { DenouncedGeneralService } from "./DenouncedGeneralService";
import { AffectedService } from "./AffectedService";
import { PoliceManifestationService } from "./PoliceManifestationService";
import { PedestrianService } from "./PedestrianService";
import { PoliceManifestationTrafficService } from "./PoliceManifestationTrafficService";
import { DenouncedTrafficService } from "./DenouncedTrafficService";
import { GeolocationStreetService } from "./GeolocationStreetService";
import { PoliceManifestationGenderService } from "./PoliceManifestationGenderService";
import { FileService } from "./FilesService";
import { RecordsIntoOutService } from "./RecordsIntoOutService";
import { RecordsExternalBackgroundService } from "./RecordsExternalBackgroundService";
import { RecordsCitationService } from "./RecordsCitationService";
import { RecordsDetainedService } from "./RecordsDetainedService";
import { RecordsUnidentifiedPerson } from "./RecordsUnidentifiedPerson";
import { ContainsService } from "./ContainsService";
import { ProcedencesService } from "./ProcedencesService";
import { WriteFileService } from "./WriteFileService";
import { PoliceManifestationGeneralService } from "./PoliceManifestationGeneralService";
import { EmailService } from "./EmailService";
import { EmailLogService } from "./EmailLogService";
import { EmailAttachmentService } from "./EmailAttachmentService";
import { LegalGuardianService } from "./LegalGuardianService";
import { RecordsLostObjectsService } from "./RecordsLostObjectsService";
import { ThirdLicenseService } from "./ThirdLicenseService";
const queryParamsFactory = new QueryParamsFactory();
const uiService = new UiService();
const apiService = new ApiService(SERVICE_URL, uiService);
const authService = new AuthService(apiService);
const usersService = new UsersService(apiService, queryParamsFactory);
const thirdsService = new ThirdsService(apiService, queryParamsFactory);
const diligencesService = new DiligencesService(apiService, queryParamsFactory);
const complainantService = new ComplainantService(apiService, queryParamsFactory);
const complainantActaService = new ComplainantActaService(apiService, queryParamsFactory);
const complainantTrafficService = new ComplainantTrafficService(apiService, queryParamsFactory);
const complainantGenderService = new ComplainantGenderService(apiService, queryParamsFactory);
const paramsService = new ParamsService(apiService, queryParamsFactory);
const kinshipsService = new KinshipsService(apiService);
const directionsService = new DirectionsService(apiService, queryParamsFactory);
const parentsService = new ParentsService(apiService, queryParamsFactory);
const vehiclesService = new VehiclesService(apiService, queryParamsFactory);
const subtypesDiligencesService = new SubtypesDiligencesService(apiService, queryParamsFactory);
const denouncedService = new DenouncedService(apiService, queryParamsFactory);
const denouncedActaService = new DenouncedActaService(apiService, queryParamsFactory);
const denouncedGenderService = new DenouncedGenderService(apiService, queryParamsFactory);
const bussinessService = new BussinessService(apiService, queryParamsFactory);
const witnessService = new WitnessService(apiService, queryParamsFactory);
const affectedService = new AffectedService(apiService, queryParamsFactory);
const lawService = new LawService(apiService, queryParamsFactory);
const lawArticleService = new LawArticleService(apiService, queryParamsFactory);
const witnessGenderService = new WitnessGenderService(apiService, queryParamsFactory);
const complainantGeneralService = new ComplainantGeneralService(apiService, queryParamsFactory);
const denouncedGeneralService = new DenouncedGeneralService(apiService, queryParamsFactory);
const policeManifestationService = new PoliceManifestationService(apiService, queryParamsFactory);
const pedestrianService = new PedestrianService(apiService, queryParamsFactory);
const policeManifestationTrafficService = new PoliceManifestationTrafficService(apiService, queryParamsFactory);
const policeManifestationGenderService = new PoliceManifestationGenderService(apiService, queryParamsFactory);
const denouncedTrafficService = new DenouncedTrafficService(apiService, queryParamsFactory);
const recordsIntoOutService = new RecordsIntoOutService(apiService, queryParamsFactory);
const recordsCitationService = new RecordsCitationService(apiService, queryParamsFactory);
const recordsDetainedService = new RecordsDetainedService(apiService, queryParamsFactory);
const recordsUnidentifiedPerson = new RecordsUnidentifiedPerson(apiService, queryParamsFactory);
const recordsExternalBackgroundService = new RecordsExternalBackgroundService(apiService, queryParamsFactory);
const geolocationStreetService = new GeolocationStreetService(uiService, paramsService);
const containsService = new ContainsService(apiService, queryParamsFactory);
const fileServices = new FileService(apiService);
const procedencesService = new ProcedencesService(apiService, queryParamsFactory);
const antecedentsService = new RecordsExternalBackgroundService(apiService, queryParamsFactory);
const writeFileService = new WriteFileService();
const policeManifestationGeneralService = new PoliceManifestationGeneralService(apiService, queryParamsFactory);
const emailService = new EmailService(apiService);
const emailLogService = new EmailLogService(apiService);
const emailAttachmentService = new EmailAttachmentService(apiService);
const legalGuardianService = new LegalGuardianService(apiService, queryParamsFactory);
const recordsLostObjectsService = new RecordsLostObjectsService(apiService, queryParamsFactory);
const thirdLicenseService = new ThirdLicenseService(apiService, queryParamsFactory);
export { uiService, authService, usersService, thirdsService, diligencesService, complainantService, complainantActaService, complainantGenderService, complainantTrafficService, paramsService, kinshipsService, directionsService, parentsService, vehiclesService, subtypesDiligencesService, denouncedService, denouncedActaService, denouncedGenderService, bussinessService, witnessService, affectedService, lawService, lawArticleService, witnessGenderService, complainantGeneralService, denouncedGeneralService, policeManifestationService, pedestrianService, policeManifestationTrafficService, policeManifestationGenderService, denouncedTrafficService, recordsIntoOutService, recordsCitationService, recordsDetainedService, recordsExternalBackgroundService, recordsUnidentifiedPerson, recordsLostObjectsService, geolocationStreetService, containsService, fileServices, procedencesService, antecedentsService, writeFileService, policeManifestationGeneralService, emailService, emailLogService, emailAttachmentService, legalGuardianService, thirdLicenseService, };
